import {utilModule} from '../module.js';

utilModule.directive("nsMaskInvalid", function() {
    return {
        restrict: "A",
        require: 'ngModel',
        link: function(scope, elem, attrs, ngModel) {
            let invalidChars = attrs.nsMaskInvalid;
            //keydown event doesn't work properly with android so we watch the model
            scope.$watch(attrs.ngModel, function(newVal, oldVal) {
                if (newVal != null && newVal !== oldVal) {
                    for (let i=0; i<invalidChars.length; i++) {
                        if (newVal.indexOf(invalidChars[i]) >= 0) {
                            ngModel.$setViewValue(newVal.replace(invalidChars[i], ''));
                            ngModel.$render();
                        }
                    }
                }
            });
        }
    }
});
